<div id="loanCalculator" class="singleCalculator">
    <div class="calc-inner calc-intro">
      <h2>Refinance Calculator</h2>
      <div class="customizer">
        <span class="customizer-text" style="color: rgb(103, 115, 117);">
          {{ refinanceCalcIntro }}
        </span>
      </div>
    </div>
    <br>
  
    <h3>Loan Details</h3>
  
    <!-- Mobile Layout -->
    <div class="d-md-none">
      <h5>Current Loan</h5>
  
      <div class="container">
        <div class="row mb-3">
          <div class="col-md-4">
            <label class="calculatorLabel margin-0" for="currentLoanAmount">Loan Amount</label>
          </div>
          <div class="col-md-5">
            <div class="input-group">
              <span class="input-group-text">$</span>
              <input type="number" class="form-control" id="currentLoanAmount" [(ngModel)]="currentLoanAmount"
                (ngModelChange)="doCalculation()">
            </div>
          </div>
        </div>
  
        <div class="row mb-3">
          <div class="col-md-4">
            <label class="calculatorLabel margin-0" for="currentInterestRate">Interest Rate</label>
          </div>
          <div class="col-md-5">
            <div class="input-group">
              <input type="number" class="form-control" id="currentInterestRate" [(ngModel)]="currentInterestRate"
                (ngModelChange)="doCalculation()">
              <span class="input-group-text">%</span>
            </div>
          </div>
        </div>
  
        <div class="row mb-3">
          <div class="col-md-4">
            <label class="calculatorLabel" for="currentTerm">Term</label>
          </div>
          <div class="col-md-5">
            <select class="form-control" aria-label="Current Term" id="currentTerm" [(ngModel)]="currentTerm"
              (ngModelChange)="doCalculation()">
              <option *ngFor="let option of termOptions" [value]="option.value">{{ option.label }}</option>
            </select>
          </div>
        </div>
  
        <div class="row mb-3">
          <div class="col-md-4">
            <label class="calculatorLabel margin-0" for="originationYear">Origination Year</label>
          </div>
          <div class="col-md-5">
            <input type="number" class="form-control" id="originationYear" [(ngModel)]="originationYear"
              (ngModelChange)="doCalculation()">
          </div>
        </div>
      </div>
  
      <h5>New Loan</h5>
      <div class="container">
        <div class="row mb-3">
          <div class="col-md-4">
            <label class="calculatorLabel margin-0" for="newBaseLoanAmount">New Loan Amount</label>
          </div>
          <div class="col-md-5">
            <div class="input-group">
              <span class="input-group-text">$</span>
              <input type="number" class="form-control" id="newBaseLoanAmount" [(ngModel)]="newBaseLoanAmount"
                (ngModelChange)="doCalculation()">
            </div>
          </div>
        </div>
  
        <div class="row mb-3">
          <div class="col-md-4">
            <label class="calculatorLabel margin-0" for="newInterestRate">New Interest Rate</label>
          </div>
          <div class="col-md-5">
            <div class="input-group">
              <input type="number" class="form-control" id="newInterestRate" [(ngModel)]="newInterestRate"
                (ngModelChange)="doCalculation()">
              <span class="input-group-text">%</span>
            </div>
          </div>
        </div>
  
        <div class="row mb-3">
          <div class="col-md-4">
            <label class="calculatorLabel" for="newTerm">New Term</label>
          </div>
          <div class="col-md-5">
            <select class="form-control" aria-label="New Term" id="newTerm" [(ngModel)]="newTerm"
              (ngModelChange)="doCalculation()">
              <option *ngFor="let option of termOptions" [value]="option.value">{{ option.label }}</option>
            </select>
          </div>
        </div>
  
        <div class="row mb-3">
          <div class="col-md-4">
            <label class="calculatorLabel margin-0" for="refinanceFees">Refinance Fees</label>
          </div>
          <div class="col-md-5">
            <div class="input-group">
              <span class="input-group-text">$</span>
              <input type="number" class="form-control" id="refinanceFees" [(ngModel)]="refinanceFees"
                (ngModelChange)="doCalculation()">
            </div>
          </div>
        </div>
  
        <div class="row mb-3">
          <div class="col-md-4">
            <label class="calculatorLabel margin-0" for="cashOut">Cash Out</label>
          </div>
          <div class="col-md-5">
            <div class="input-group">
              <span class="input-group-text">$</span>
              <input type="number" class="form-control" id="cashOut" [(ngModel)]="cashOut"
                (ngModelChange)="doCalculation()">
            </div>
          </div>
        </div>
  
        <div class="row mb-3">
          <div class="col-md-4">
            <label class="calculatorLabel margin-0" for="rollFees">Roll Fees into New Loan?</label>
          </div>
          <div class="col-md-5">
            <div class="form-check">
              <input type="checkbox" class="form-check-input" id="rollFees" [(ngModel)]="rollFees"
                (change)="doCalculation()">
              <label class="form-check-label" for="rollFees">Yes</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  
    <!-- Desktop Layout (3 Column) -->
    <div class="d-none d-md-block container">
      <div class="row">
        <div class="col-md-4"></div>
        <div class="col-md-4">
          <h2>Current</h2>
        </div>
        <div class="col-md-4">
          <h2>New</h2>
        </div>
      </div>
  
      <div class="row mb-3">
        <div class="col-md-4">
          <label class="calculatorLabel margin-0" for="currentLoanAmount">Loan Amount</label>
        </div>
        <div class="col-md-4">
          <div class="input-group">
            <span class="input-group-text">$</span>
            <input type="number" class="form-control" id="currentLoanAmount" [(ngModel)]="currentLoanAmount"
              (ngModelChange)="doCalculation()">
          </div>
        </div>
        <div class="col-md-4">
          <div class="input-group">
            <span class="input-group-text">$</span>
            <input type="number" class="form-control" id="newBaseLoanAmount" [(ngModel)]="newBaseLoanAmount"
              (ngModelChange)="doCalculation()">
          </div>
        </div>
      </div>
  
      <div class="row mb-3">
        <div class="col-md-4">
          <label class="calculatorLabel margin-0" for="currentInterestRate">Interest Rate</label>
        </div>
        <div class="col-md-4">
          <div class="input-group">
            <input type="number" class="form-control" id="currentInterestRate" [(ngModel)]="currentInterestRate"
              (ngModelChange)="doCalculation()">
            <span class="input-group-text">%</span>
          </div>
        </div>
        <div class="col-md-4">
          <div class="input-group">
            <input type="number" class="form-control" id="newInterestRate" [(ngModel)]="newInterestRate"
              (ngModelChange)="doCalculation()">
            <span class="input-group-text">%</span>
          </div>
        </div>
      </div>
  
      <div class="row mb-3">
        <div class="col-md-4">
          <label class="calculatorLabel" for="currentTerm">Term</label>
        </div>
        <div class="col-md-4">
          <select class="form-control" aria-label="Current Term" id="currentTerm" [(ngModel)]="currentTerm"
            (ngModelChange)="doCalculation()">
            <option *ngFor="let option of termOptions" [value]="option.value">{{ option.label }}</option>
          </select>
        </div>
        <div class="col-md-4">
          <select class="form-control" aria-label="New Term" id="newTerm" [(ngModel)]="newTerm"
            (ngModelChange)="doCalculation()">
            <option *ngFor="let option of termOptions" [value]="option.value">{{ option.label }}</option>
          </select>
        </div>
      </div>
  
      <div class="row mb-3">
        <div class="col-md-4">
          <label class="calculatorLabel margin-0" for="originationYear">Origination Year</label>
        </div>
        <div class="col-md-4">
          <input type="number" class="form-control" id="originationYear" [(ngModel)]="originationYear"
            (ngModelChange)="doCalculation()">
        </div>
        <div class="col-md-4">
  
        </div>
      </div>
  
      <div class="row mb-3">
        <div class="col-md-4">
          <label class="calculatorLabel margin-0" for="refinanceFees">Refinance Fees</label>
        </div>
        <div class="col-md-4"></div>
        <div class="col-md-4">
          <div class="input-group">
            <span class="input-group-text">$</span>
            <input type="number" class="form-control" id="refinanceFees" [(ngModel)]="refinanceFees"
              (ngModelChange)="doCalculation()">
          </div>
        </div>
      </div>
  
      <div class="row mb-3">
        <div class="col-md-4">
          <label class="calculatorLabel margin-0" for="cashOut">Cash Out</label>
        </div>
        <div class="col-md-4"></div>
        <div class="col-md-4">
          <div class="input-group">
            <span class="input-group-text">$</span>
            <input type="number" class="form-control" id="cashOut" [(ngModel)]="cashOut"
              (ngModelChange)="doCalculation()">
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-4">
          <label class="calculatorLabel margin-0" for="rollFees">Roll Fees into New Loan?</label>
        </div>
        <div class="col-md-4"></div>
        <div class="col-md-4">
          <div class="input-group">
            <div class="form-check">
              <mat-slide-toggle type="checkbox" class="form-check-input" id="rollFees" [(ngModel)]="rollFees"
                (change)="doCalculation()" style="border: 0px;"></mat-slide-toggle>
            </div>
          </div>
        </div>
      </div>
    </div>
  
    <h3>Results</h3>
    <!-- Results Section -->
    <div class="d-md-block" style="width: auto;">
  
      <div id="desktop-results" class="container">
        <div class="row mb-2 d-flex justify-content-between">
          <div class="col-md-6">
            <p class="resultValueLabel">You could save</p>
          </div>
          <div class="col-md-6 d-flex justify-content-end align-items-end">
            <span class="mainResultValue">{{ monthlySavings | currency }}</span>
            <span class="results-tag"> / mo</span>
          </div>
        </div>
  
        <div class="row mb-2 d-flex justify-content-between">
          <div class="col-md-6">
            <p class="resultValueLabelSmall">New monthly payment</p>
          </div>
          <div class="col-md-6 d-flex justify-content-end align-items-end">
            <span class="mainResultValue">{{ newPayment | currency }}</span>
            <span class="results-tag"> / mo</span>
          </div>
        </div>
      </div>
  
      <h5>Calculation Details</h5>
      <div class="d-md-block container" style="width: auto;">
        <div class="row mb-2 d-flex justify-content-between">
          <div class="col-md-6">
            <p>Breakeven in</p>
          </div>
          <div class="col-md-6 d-flex justify-content-end">
            <p class="resultValue">{{ breakEven === 'N/A' ? breakEven : breakEven === 1 ? breakEven + ' month' :
              breakEven + ' months' }}</p>
          </div>
        </div>
  
        <div class="row mb-2 d-flex justify-content-between" *ngIf="fiveYearSavings > 0">
          <div class="col-md-6">
            <p>Savings after 5 years</p>
          </div>
          <div class="col-md-6 d-flex justify-content-end">
            <p [ngClass]="{'resultValue': fiveYearSavings < 0, 'resultValueHighlight': fiveYearSavings >= 0}">
              {{ fiveYearSavings | currency }}</p>
          </div>
        </div>
  
        <div class="row mb-2 d-flex justify-content-between" *ngIf="tenYearSavings > 0">
          <div class="col-md-6">
            <p>Savings after 10 years</p>
          </div>
          <div class="col-md-6 d-flex justify-content-end">
            <p [ngClass]="{'resultValue': tenYearSavings < 0, 'resultValueHighlight': tenYearSavings >= 0}">
              {{ tenYearSavings | currency }}</p>
          </div>
        </div>
  
        <div class="row mb-2 d-flex justify-content-between" *ngIf="fifteenYearSavings > 0">
          <div class="col-md-6">
            <p>Savings after 15 years</p>
          </div>
          <div class="col-md-6 d-flex justify-content-end">
            <p [ngClass]="{'resultValue': fifteenYearSavings < 0, 'resultValueHighlight': fifteenYearSavings >= 0}">
              {{ fifteenYearSavings | currency }}</p>
          </div>
        </div>
  
        <div class="row mb-2 d-flex justify-content-between" *ngIf="twentyYearSavings > 0">
          <div class="col-md-6">
            <p>Savings after 20 years</p>
          </div>
          <div class="col-md-6 d-flex justify-content-end">
            <p [ngClass]="{'resultValue': twentyYearSavings < 0, 'resultValueHighlight': twentyYearSavings >= 0}">
              {{ twentyYearSavings | currency }}</p>
          </div>
        </div>
  
        <div class="row d-flex justify-content-between">
          <div class="col-md-6">
            <p>{{ lifetimeSavings > 0 ? 'Lifetime savings' : 'Extra lifetime cost of new loan' }}</p>
          </div>
          <div class="col-md-6 d-flex justify-content-end">
            <p class="mainResultValue pe-0">{{ (lifetimeSavings > 0 ? lifetimeSavings : - lifetimeSavings) | currency }}</p>
          </div>
        </div>
      </div>
    </div>
  
  </div>